import { encodeBase64 } from '@frontend/string';
import { useNavigate, type AnyRoute } from '@frontend/weave-router';
import { useCommonActionSubscriptions } from './actions/use-common-actions-subscriptions';
import { useNotificationActionSubscription } from './actions/use-notification-action-subscription';
import { useNotification } from './use-notification';

export const useReviewNotification = () => {
  const { create, remove } = useNotification<'review-new'>();
  const navigate = useNavigate();
  useCommonActionSubscriptions('review-new');
  useNotificationActionSubscription('review-new', 'view', (e) => {
    navigate({
      to: `/reviews/all-reviews/${encodeBase64(e.notification.payload.reviewId)}` as AnyRoute,
      //TODO: @gisheri - remove this any after migrating the route
      search: {
        type: e.notification.payload.siteName,
      } as any,
    });
    remove(e.notification.id);
  });
  return {
    create,
    remove,
  };
};
